// Dependencies
import { FC } from "react";

// Components
import { MenuItem, Select, SvgIcon } from "@mui/material";
import { USER_ROLE } from "~/enums";

// Icons
import { ReactComponent as OwnerIcon } from "~/assets/icons/user-gear-solid.svg";
import { ReactComponent as MemberIcon } from "~/assets/icons/user-solid.svg";

// Styles
import {
  StyledUserRoleIcon,
  StyledUserRoleSelect,
  StyledUserSelect,
} from "./WalletAddMember.styled";

interface UserRoleSelectProps {}

const userRoleList = USER_ROLE.map((role: string) => (
  <MenuItem value={role}>{role}</MenuItem>
));

const UserRoleSelect: FC<UserRoleSelectProps> = () => {
  return (
    <StyledUserRoleSelect>
      <StyledUserRoleIcon>
        <OwnerIcon />
      </StyledUserRoleIcon>
      <StyledUserSelect defaultValue={"Member"}>
        {userRoleList}
      </StyledUserSelect>
    </StyledUserRoleSelect>
  );
};

export default UserRoleSelect;
